import request from "../shared/http";
import appConfig from "../shared/js/app-config";

const sid = (serviceId) => serviceId || appConfig.getServiceId();
const unwrap = (res) => res?.data ?? res;

class TicketService {
  listEvents(serviceId) {
    return request.get(`/vertical/${sid(serviceId)}/ticket-events`).then(unwrap);
  }

  createEvent(payload, serviceId) {
    return request.post(`/vertical/${sid(serviceId)}/ticket-events`, payload).then(unwrap);
  }

  updateEvent(eventId, payload, serviceId) {
    return request.put(`/vertical/${sid(serviceId)}/ticket-events/${eventId}`, payload).then(unwrap);
  }

  deleteEvent(eventId, serviceId) {
    return request.delete(`/vertical/${sid(serviceId)}/ticket-events/${eventId}`).then(unwrap);
  }

  listTiers(eventId, serviceId) {
    return request.get(`/vertical/${sid(serviceId)}/ticket-events/${eventId}/tiers`).then(unwrap);
  }

  createTier(eventId, payload, serviceId) {
    return request.post(`/vertical/${sid(serviceId)}/ticket-events/${eventId}/tiers`, payload).then(unwrap);
  }

  updateTier(eventId, tierId, payload, serviceId) {
    return request
      .put(`/vertical/${sid(serviceId)}/ticket-events/${eventId}/tiers/${tierId}`, payload)
      .then(unwrap);
  }

  deleteTier(eventId, tierId, serviceId) {
    return request
      .delete(`/vertical/${sid(serviceId)}/ticket-events/${eventId}/tiers/${tierId}`)
      .then(unwrap);
  }

  listBookings(serviceId) {
    return request.get(`/vertical/${sid(serviceId)}/ticket-bookings`).then(unwrap);
  }

  cancelBooking(bookingId, payload = {}, serviceId) {
    return request
      .post(`/vertical/${sid(serviceId)}/ticket-bookings/${bookingId}/cancel`, payload)
      .then(unwrap);
  }

  reduceLine(bookingId, payload = {}, serviceId) {
    return request
      .post(`/vertical/${sid(serviceId)}/ticket-bookings/${bookingId}/reduce-line`, payload)
      .then(unwrap);
  }

  tierAvailability(ticketTierId, serviceId) {
    return request
      .post(`/vertical/${sid(serviceId)}/ticket/actions/tier-availability`, {
        ticket_tier_id: ticketTierId,
      })
      .then(unwrap);
  }

  listPackageDepartures(packageEventId, serviceId) {
    return request
      .get(`/vertical/${sid(serviceId)}/ticket-packages/${packageEventId}/departures`)
      .then(unwrap);
  }

  listTripAddons(payload, serviceId) {
    return request
      .post(`/vertical/${sid(serviceId)}/ticket/actions/trip-addons`, payload)
      .then(unwrap);
  }

  actionRegistry() {
    return request.get("/vertical/actions-registry").then(unwrap);
  }
}

export default new TicketService();
